<template>
	<div class="payment-layout">
		<child/>
	</div>
</template>

<script>
export default {
	name: 'payment-layout'
}
</script>

<style lang="scss">
	.payment-layout {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100vh;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/payment.vue